import { Button, Card, Form, Input } from "antd";
import { Toast } from "primereact/toast"; // Replace react-hot-toast import
import { LockOutlined } from "@ant-design/icons";
import HTTPService from "../../../utils/makerequest";
import { IPageProps } from "../../../interfaces/page-data";
import { StateLoader } from "../../../redux/StateLoader";
import { IAuthentication } from "../../../interfaces/authentication";
import { t } from "i18next";
import { useRef } from "react"; // Add useRef import

const PagePasswordChange: React.FunctionComponent<IPageProps> = () => {
    const loader = new StateLoader();
    const authInfo: IAuthentication = loader.loadAuthState();
    const toast = useRef<any>(null); // Add toast ref

    const update = (values) => {
        if (values.retryNewPassword === values.newPassword) {
            HTTPService.PUT(`/User/PasswordChange?email=${authInfo.email}&oldPassword=${values.oldPassword}&newPassword=${values.newPassword}`, {})
                .then((res) => {
                    if (res.status === 200) {
                        toast.current?.show({
                            severity: 'success',
                            summary: t('successful'),
                            detail: t(res.data),
                            life: 3000
                        });
                    } else if (res.status === 450) {
                        toast.current?.show({
                            severity: 'error',
                            summary: t('errors'),
                            detail: t(res.data),
                            life: 3000
                        });
                    } else {
                        toast.current?.show({
                            severity: 'error',
                            summary: t('errors'),
                            detail: t(res.data),
                            life: 3000
                        });
                    }
                })
                .catch(error => {
                    toast.current?.show({
                        severity: 'error',
                        summary: t('errors'),
                        detail: t('There was an error!'),
                        life: 3000
                    });
                });
        } else {
            toast.current?.show({
                severity: 'error',
                summary: t('errors'),
                detail: t('Your New Password Does Not Match!!!'),
                life: 3000
            });
        }
    };

    return (
        <Card style={{ padding: '50px' }}>
            <Toast ref={toast} />
            <h3>{t('Reset Password')}</h3>
            <Form layout='vertical' onFinish={update}>
                <Form.Item
                    name='oldPassword'
                    label={t('Old Password')}
                    rules={[{ required: true, message: t('Please input your old password!') }]}
                >
                    <Input.Password
                        prefix={<LockOutlined />}
                        placeholder={t('Old Password')}
                        style={{ borderRadius: 0 }}
                    />
                </Form.Item>
                <Form.Item
                    name='newPassword'
                    label={t('New Password')}
                    rules={[{ required: true, message: t('Please input your new password!') }]}
                >
                    <Input.Password
                        prefix={<LockOutlined />}
                        placeholder={t('New Password')}
                        style={{ borderRadius: 0 }}
                    />
                </Form.Item>
                <Form.Item
                    name='retryNewPassword'
                    label={t('Retry New Password')}
                    dependencies={['newPassword']}
                    hasFeedback
                    rules={[
                        { required: true, message: t('Please confirm your new password!') },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (!value || getFieldValue('newPassword') === value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(t('The two passwords do not match!'));
                            },
                        }),
                    ]}
                >
                    <Input.Password
                        prefix={<LockOutlined />}
                        placeholder={t('Retry New Password')}
                        style={{ borderRadius: 0 }}
                    />
                </Form.Item>
                <Form.Item>
                    <div className='span d-flex justify-content-between'>
                        <span />
                        <Button htmlType="submit" type="primary" style={{ borderRadius: 0 }}>
                            {t('save')}
                        </Button>
                    </div>
                </Form.Item>
            </Form>
        </Card>
    );
}

export default PagePasswordChange;
